
const register = resolve =>{
  import('./register').then(module=>{
    resolve(module)
  })
}

export default [
  {
    path: '/register',
    name: 'register',
    component: register,
    meta: {
      auth: false,
      title: '注册'
    }
  }
]



// WEBPACK FOOTER //
// ./src/module/register/router.js